import { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useWagmi } from 'libs/wagmi'
import { AppState } from 'state'
import { useFastRefreshEffect } from './useRefreshEffect'

// combines the block timestamp with the user setting to give the deadline that should be used for any submitted transaction
export default function useTransactionDeadline(): number {
  const ttl = useSelector<AppState, number>((state) => state.user.userDeadline)
  const { provider } = useWagmi()
  const [currentBlockTimestamp, setCurrentBlockTimestamp] = useState(0)

  useFastRefreshEffect(() => {
    const fetchCurrentBlockTimestamp = async () => {
      const { timestamp } = await provider.getBlock('pending')

      setCurrentBlockTimestamp(timestamp)
    }

    fetchCurrentBlockTimestamp()
  }, [])

  return useMemo(
    () => (currentBlockTimestamp ? currentBlockTimestamp + ttl : Math.floor(Date.now() / 1000) + ttl),
    [currentBlockTimestamp, ttl],
  )
}
